import { useTranslation } from 'react-i18next'

import { Card } from '@/components/ui/Card'
import { env } from '@/config/env'
import { useTelegramUser } from '@/telegram'

export function HomePage() {
  const { t } = useTranslation()
  const telegramUser = useTelegramUser()
  const displayName = telegramUser?.first_name ?? t('home.guestName')

  return (
    <main className="flex flex-col gap-4 py-4">
      <header className="flex flex-col gap-1">
        <h1 className="text-xl font-bold">{t('home.greeting', { name: displayName })}</h1>
        <p className="text-sm text-secondary">{t('home.subtitle')}</p>
      </header>

      <Card className="flex flex-col gap-1">
        <h2 className="text-sm font-semibold">{t('home.statusTitle')}</h2>
        <p className="text-xs text-muted">
          {t('home.statusDescription', { environment: env.appEnvironment })}
        </p>
      </Card>
    </main>
  )
}
